import { render } from "./supplier.vue?vue&type=template&id=00d2d6f2&scoped=true"
import script from "./supplier.vue?vue&type=script&lang=js"
export * from "./supplier.vue?vue&type=script&lang=js"

import "./supplier.vue?vue&type=style&index=0&id=00d2d6f2&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d2d6f2"]])

export default __exports__